import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './motoristaFolgaForm';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import ReactExport from 'react-export-excel-fixed-xlsx';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import InputPesquisa from '../common/form/inputPesquisa';
import Aguardando from '../common/template/aguardando';
import Select from '../common/form/select';
import LabelAndInputDate from '../common/form/labelAndInputDate';

import { 
	setModoTela, setFiltro, initForm, salvar, excluir, getLista, getListaMotorista, getListaPlaca, 
	getListaTipo, getListaEstado, getListaEstadoTroca, getListaCidadeSelect,
	getListaEmails
} from './motoristaFolgaActions';
import { 
	getLista as getListaMotivo
} from '../motoristaFolgaMotivo/motoristaFolgaMotivoActions';

import { 
	getLista as getListaGrupo
} from '../gestaoVMGrupo/gestaoVMGrupoActions';

import { 
	getLista as getListaGrupoEmail
} from '../grupoEmail/grupoEmailActions';
import { 
	getLista as getListaMotoristaGrupo
} from '../motoristaGrupo/motoristaGrupoActions';

class MotoristaFolga extends Component {

	state = {
		linhaSelecionada: null,
		linhasTrocasAbertas: [],
		ordenacao: {
			data_planejamento_inicio: 2
		}
	}

    componentWillMount() {
		this.props.setModoTela('lista');
        this.props.getLista();
		this.props.getListaMotorista();
		this.props.getListaPlaca();
		this.props.getListaTipo();
		this.props.getListaEstado();
		this.props.getListaMotivo();
		this.props.getListaGrupo();
		this.props.getListaEstadoTroca();
		this.props.getListaGrupoEmail();
		this.props.getListaMotoristaGrupo();
		this.props.getListaCidadeSelect();
    }

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form tratativa onSubmit={(registro) => this.props.salvar(registro)} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form tratativa excluir onSubmit={(registro) => this.props.excluir(registro)} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	getNovaOrdenacao(atual) {
		return atual == 2 ? 0 : (atual || 0) + 1;
	}

	getIconeOrdenacao(tipo) {
		if (tipo == 1) {
			return <i class="fas fa-sort-amount-down-alt" />;
		} else if (tipo == 2) {
			return <i class="fas fa-sort-amount-up" />;
		} else {
			return null;
		}
	}

	estaAtrasado(registro) {

		if (!registro) {
			return false;
		}

		const estado = (registro.nome_estado || '').trim().toUpperCase();

		if (
			estado == 'CONCLUÍDA' ||
			estado == 'CANCELADO'
		) {
			return false;
		}

		if (!registro.data_termino) {
			return false;
		}

		const hoje = new Date();
		hoje.setHours(0, 0, 0, 0);

		const dataTermino =
			new Date(registro.data_termino);

		return dataTermino < hoje;
	}

	lista() {

		const ExcelFile = ReactExport.ExcelFile;
		const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
		const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

		let lista = this.props.lista.filter(item => {

			return !(this.props.filtro.pesquisar || '').trim()
				|| (this.props.filtro.pesquisar.toUpperCase() || '').split('+').filter(pesquisar => (pesquisar || '').trim()).filter(pesquisar => {
				if (pesquisar
					&& !(`
						${item.nome_motorista}
						${item.placa}
						${item.nome_motorista_grupo}
						${item.nome_grupo_veiculo}
						${item.nome_tipo}
						${item.nome_estado}
						${item.nome_motivo}
						${DateFormat.formatarDataSqlParaTela(item.data_planejamento_inicio)}
						${DateFormat.formatarDataSqlParaTela(item.data_inicio)}
						${DateFormat.formatarDataSqlParaTela(item.data_termino)}
						${item.veiculo_local}

						${!this.props.filtro.geral ? '' : (item.trocas || []).filter(troca => !troca.id || troca.ativo).map(troca => {

							const motorista = this.props.listaMotorista.find(itemMotorista => itemMotorista.id == troca.id_motorista);
							const estado = (this.props.listaEstadoTrocas || []).find(itemEstado => itemEstado.id == troca.id_estado);

							return `
								${troca.nome_motorista || (motorista ? motorista.valor : '')}
								${troca.leva ? 'Leva' : 'Troca'}
								${DateFormat.formatarDataSqlParaTela(troca.data_previsao_inicio) || ''}
								${DateFormat.formatarDataSqlParaTela(troca.data_inicio)}
								${DateFormat.formatarDataSqlParaTela(troca.data_termino) || ''}
								${troca.nome_estado || (estado ? estado.valor : '')}																									
								${troca.localizacao || ''}
								${troca.municipio || ''}
								${troca.placa || ''}
								${troca.shipping || ''}
								${troca.rumo || ''}
								${troca.proxima_etapa || ''}
								${troca.nome_etapa || ''}
								${DateFormat.formatarDataHoraSqlParaTela(troca.data_previsao_etapa) || ''}
								${troca.observacao}
							`;
						}).join('\n')}
				`).toUpperCase().includes(pesquisar)) {
					return false;
				}

				return true;

			}).length > 0;
			
		});

		if (this.state.ordenacao.nome_motorista) {
			lista.sort((a, b) => this.state.ordenacao.nome_motorista == 1 
				? (a.nome_motorista > b.nome_motorista ? 1 : -1) 
				: (a.nome_motorista > b.nome_motorista ? -1 : 1));
		} else if (this.state.ordenacao.placa) {
			lista.sort((a, b) => this.state.ordenacao.placa == 1 
				? ((a.placa || '') > (b.placa || '') ? 1 : -1) 
				: ((a.placa || '') > (b.placa || '') ? -1 : 1));
		} else if (this.state.ordenacao.nome_grupo_veiculo) {
			lista.sort((a, b) => this.state.ordenacao.nome_grupo_veiculo == 1 
				? (`${(a.nome_motorista_grupo || '')}${(a.nome_grupo_veiculo || '')}` > `${(b.nome_motorista_grupo || '')}${(b.nome_grupo_veiculo || '')}` ? 1 : -1) 
				: (`${(a.nome_motorista_grupo || '')}${(a.nome_grupo_veiculo || '')}` > `${(b.nome_motorista_grupo || '')}${(b.nome_grupo_veiculo || '')}` ? -1 : 1));
		} else if (this.state.ordenacao.nome_tipo) {
			lista.sort((a, b) => this.state.ordenacao.nome_tipo == 1 
				? (a.nome_tipo > b.nome_tipo ? 1 : -1) 
				: (a.nome_tipo > b.nome_tipo ? -1 : 1));
		} else if (this.state.ordenacao.nome_estado) {
			lista.sort((a, b) => this.state.ordenacao.nome_estado == 1 
				? (a.nome_estado > b.nome_estado ? 1 : -1) 
				: (a.nome_estado > b.nome_estado ? -1 : 1));
		} else if (this.state.ordenacao.nome_motivo) {
			lista.sort((a, b) => this.state.ordenacao.nome_motivo == 1 
				? (a.nome_motivo > b.nome_motivo ? 1 : -1) 
				: (a.nome_motivo > b.nome_motivo ? -1 : 1));
		} else if (this.state.ordenacao.data_planejamento_inicio) {
			lista.sort((a, b) => this.state.ordenacao.data_planejamento_inicio == 1 
				? ((a.data_planejamento_inicio || '0') > (b.data_planejamento_inicio || '0') ? 1 : -1) 
				: ((a.data_planejamento_inicio || '0') > (b.data_planejamento_inicio || '0') ? -1 : 1));
		} else if (this.state.ordenacao.data_inicio) {
			lista.sort((a, b) => this.state.ordenacao.data_inicio == 1 
				? ((a.data_inicio || '0') > (b.data_inicio || '0') ? 1 : -1) 
				: ((a.data_inicio || '0') > (b.data_inicio || '0') ? -1 : 1));
		} else if (this.state.ordenacao.data_termino) {
			lista.sort((a, b) => this.state.ordenacao.data_termino == 1 
				? ((a.data_termino || '0') > (b.data_termino || '0') ? 1 : -1) 
				: ((a.data_termino || '0') > (b.data_termino || '0') ? -1 : 1));
		} else if (this.state.ordenacao.veiculo_local) {
			lista.sort((a, b) => this.state.ordenacao.veiculo_local == 1 
				? ((a.veiculo_local || '') > (b.veiculo_local || '') ? 1 : -1) 
				: ((a.veiculo_local || '') > (b.veiculo_local || '') ? -1 : 1));
		}

		return (
			<ContentCard>
				<ContentCardBody>
					<Row>
						<div style={{ display: 'flex', flexDirection: 'column', paddingTop: 29 }}>
							<div class={`filter-chip ${this.props.filtro.geral ? 'active' : ''}`}
								style={{ width: 80, height: 16, fontSize: 9, marginBottom: 0, marginTop: 0, marginRight: 0 }}
								onClick={() => {
									this.props.setFiltro({
										...this.props.filtro,
										geral: !this.props.filtro.geral
									});
								}}>
								<i class='fas fa-search' style={{ fontSize: 12 }}></i> Geral
							</div>
							<div class={`filter-chip ${!this.props.filtro.geral ? 'active' : ''}`}
								style={{ width: 80, height: 16, fontSize: 9, marginBottom: 0, marginTop: 4, marginRight: 0 }}
								onClick={() => {
									this.props.setFiltro({
										...this.props.filtro,
										geral: !this.props.filtro.geral
									});
								}}>
								<i class='fas fa-search' style={{ fontSize: 12 }}></i> Resumido
							</div>
						</div>
						<InputPesquisa
							cols='12 12 4 4'
							maxWidth={350}
							minWidth={350}							
							label='Pesquisar'
							value={this.props.filtro.pesquisar}
							onChange={value => this.props.setFiltro({ ...this.props.filtro, pesquisar: value })} />

						<Select
							name='periodo'
							component={Select}
							options={[{ id: 'previsao', valor: 'Previsão' }, { id: 'inicio', valor: 'Início' }, { id: 'termino', valor: 'Término' }]}
							label='Período'
							maxWidth={200}
							minWidth={200}
							cols='12 12 4 4'
							placeholder='Selecione'
							value={this.props.filtro.periodo}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									periodo: value
								});
							}} />
						<LabelAndInputDate
							label='Inicial'
							cols='12 6 4 4'
							value={this.props.filtro.data_inicial}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									data_inicial: value
								});
							}} />

						<LabelAndInputDate
							label='Final'
							cols='12 6 4 4'
							value={this.props.filtro.data_final}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									data_final: value
								});
							}} />

						<Select
							name='id_motorista'
							component={Select}
							options={this.props.listaMotorista}
							label='Motorista'
							maxWidth={220}
							minWidth={220}
							cols='12 12 4 4'
							placeholder='Selecione'
							value={this.props.filtro.id_motorista}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									id_motorista: value
								})
							}} />

						<Select
							name='placa'
							component={Select}
							options={this.props.listaPlaca.map(item => ({ id: item.placa, valor: item.placa }))}
							label='Placa'
							maxWidth={165}
							minWidth={165}
							cols='12 12 4 4'
							placeholder='Selecione'
							value={this.props.filtro.placa}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									placa: value
								})
							}} />

						<Select
							name='id_grupo_veiculo'
							component={Select}
							options={this.props.listaGrupo}
							label='Grupo de Veículo'
							maxWidth={220}
							minWidth={220}
							cols='12 12 4 4'
							placeholder='Selecione'
							value={this.props.filtro.id_grupo_veiculo}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									id_grupo_veiculo: value
								});
							}} />

						<Select
							options={this.props.listaMotoristaGrupo}
							label='Grupo de Motorista'
							maxWidth={220}
							minWidth={220}
							cols='12 12 4 4'
							placeholder='Selecione'
							value={this.props.filtro.id_motorista_grupo}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									id_motorista_grupo: value
								});
							}} />

						<Select
							name='id_estado'
							component={Select}
							options={this.props.listaEstado}
							label='Estado'
							maxWidth={180}
							minWidth={180}
							cols='12 12 4 4'
							placeholder='Selecione'
							value={this.props.filtro.id_estado}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									id_estado: value
								})
							}} />
						
						<Select
							name='id_tipo'
							component={Select}
							options={this.props.listaTipo}
							label='Tipo'
							maxWidth={180}
							minWidth={180}
							cols='12 12 4 4'
							placeholder='Selecione'
							value={this.props.filtro.id_tipo}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									id_tipo: value
								})
							}} />
						
						<Select
							name='id_motivo'
							component={Select}
							options={this.props.listaMotivo}
							label='Motivo'
							maxWidth={180}
							minWidth={180}
							cols='12 12 4 4'
							placeholder='Selecione'
							value={this.props.filtro.id_motivo}
							onChange={value => {
								this.props.setFiltro({
									...this.props.filtro,
									id_motivo: value
								})
							}} />
						
						<div style={{ width: 390, marginTop: 8, marginLeft: 8 }}>
							<a
								class='btn btn-app bg-secondary'
								style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setFiltro({
										...this.props.filtro,
										pesquisar: '',
										data_inicial: null,
										data_final: null,
										id_motorista: null,
										placa: null,
										id_grupo_veiculo: null,
										id_motorista_grupo: null,
										id_estado: null,
										id_tipo: null,
										id_motivo: null
									});

									this.setState({
										linhaSelecionada: null
									});
									
									this.props.getLista();
								}}
							>
								<i class='fas fa-eraser'></i> Limpar
							</a>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.getLista();
								}}>
								<i class='fas fa-sync-alt'></i> Atualizar
							</a>

							<a class='btn btn-app bg-primary' style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => {
									this.props.setModoTela('cadastro', {});
									this.props.initForm({});
									this.props.getListaEmails(null);
								}}>
								<i class='fas fa-plus'></i> Adicionar
							</a>

							<a
								className='btn btn-app bg-primary'
								style={{ marginLeft: 2, minWidth: 75 }}
								onClick={() => this.alternarTodasTrocas()}
							>
								<i
									className={
										(this.state.linhasTrocasAbertas || []).length > 0
											? 'fas fa-compress'
											: 'fas fa-expand'
									}
								></i>
								{
									(this.state.linhasTrocasAbertas || []).length > 0
										? 'Minimizar'
										: 'Expandir'
								}
							</a>

							<ExcelFile
								filename={'Folgas e Férias'}
								element={
									<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}>
										<i class='fas fa-file-excel'></i> Exportar
									</a>
								}>
								<ExcelSheet data={lista.map(item => ({
									...item,
									data_planejamento_inicio: DateFormat.formatarDataSqlParaTela(item.data_planejamento_inicio),
									data_inicio: DateFormat.formatarDataSqlParaTela(item.data_inicio),
									data_termino: DateFormat.formatarDataSqlParaTela(item.data_termino),
								}))} name='Folgas e Férias'>
									<ExcelColumn label='Motorista' value='nome_motorista' />
									<ExcelColumn label='Placa' value='placa' />
									<ExcelColumn label='Grupo de Veículo' value='nome_grupo_veiculo' />
									<ExcelColumn label='Grupo de Motorista' value='nome_motorista_grupo' />
									<ExcelColumn label='Tipo ' value='nome_tipo' />
									<ExcelColumn label='Estado' value='nome_estado' />
									<ExcelColumn label='Motivo' value='nome_motivo' />
									<ExcelColumn label='Prev. Início' value='data_planejamento_inicio' />
									<ExcelColumn label='Início' value='data_inicio' />
									<ExcelColumn label='Término' value='data_termino' />
									<ExcelColumn label='Observação' value='observacao' />
									<ExcelColumn label='Local' value='veiculo_local' />
								</ExcelSheet>
							</ExcelFile>

						</div>
					</Row>

					<div 
						style={{ 
							backgroundColor: '#1F3066',
							marginLeft: -8,
							marginRight: -8,
							marginBottom: -8,
							paddingTop: 1,
							paddingLeft: 8,
							paddingRight: 8,
							paddingBottom: 8,
							height: window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? `${window.innerHeight - 300}px`
									: (
										window.innerWidth < 1799
											? `${window.innerHeight - 260}px`
											: (
												window.innerWidth < 4000
													? `${window.innerHeight - 260}px`
													: `${window.innerHeight - 190}px`
											)
									)
							)
						}}>
						<Table responsive border striped alturaFixa
							maxHeight={window.innerWidth < 768 ? '100%' : window.innerWidth < 768 ? '100%' : (
								window.innerWidth < 1093 ? `${window.innerHeight - 300}px`
									: (
										window.innerWidth < 1799
											? `${window.innerHeight - 260}px`
											: (
												window.innerWidth < 4000
													? `${window.innerHeight - 260}px`
													: `${window.innerHeight - 190}px`
											)
									)
							)}>
							<THead>
								<Tr backgroundColor={'#1F3066'}
									color={'#ffffff'}
									height={47}>
									<Th paddingTop={2} paddingBottom={2} width={400}
										onClick={() => this.setState({ ...this.state, ordenacao: { nome_motorista: this.getNovaOrdenacao(this.state.ordenacao.nome_motorista) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Motorista {this.getIconeOrdenacao(this.state.ordenacao.nome_motorista)}</Th>
									<Th paddingTop={2} paddingBottom={2} width={100}
										onClick={() => this.setState({ ...this.state, ordenacao: { placa: this.getNovaOrdenacao(this.state.ordenacao.placa) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Placa {this.getIconeOrdenacao(this.state.ordenacao.placa)}</Th>
									<Th paddingTop={2} paddingBottom={2} width={100}
										onClick={() => this.setState({ ...this.state, ordenacao: { nome_grupo_veiculo: this.getNovaOrdenacao(this.state.ordenacao.nome_grupo_veiculo) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Grupo {this.getIconeOrdenacao(this.state.ordenacao.nome_grupo_veiculo)}</Th>
									<Th paddingTop={2} paddingBottom={2} width={200}
										onClick={() => this.setState({ ...this.state, ordenacao: { nome_tipo: this.getNovaOrdenacao(this.state.ordenacao.nome_tipo) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Tipo {this.getIconeOrdenacao(this.state.ordenacao.nome_tipo)}</Th>
									<Th paddingTop={2} paddingBottom={2} width={200}
										onClick={() => this.setState({ ...this.state, ordenacao: { nome_estado: this.getNovaOrdenacao(this.state.ordenacao.nome_estado) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Estado {this.getIconeOrdenacao(this.state.ordenacao.nome_estado)}</Th>
									<Th paddingTop={2} paddingBottom={2} width={200}
										onClick={() => this.setState({ ...this.state, ordenacao: { nome_motivo: this.getNovaOrdenacao(this.state.ordenacao.nome_motivo) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Motivo {this.getIconeOrdenacao(this.state.ordenacao.nome_motivo)}</Th>
									<Th paddingTop={2} paddingBottom={2} width={100}
										onClick={() => this.setState({ ...this.state, ordenacao: { data_planejamento_inicio: this.getNovaOrdenacao(this.state.ordenacao.data_planejamento_inicio) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Prev. Início {this.getIconeOrdenacao(this.state.ordenacao.data_planejamento_inicio)}</Th>
									<Th paddingTop={2} paddingBottom={2} width={100}
										onClick={() => this.setState({ ...this.state, ordenacao: { data_inicio: this.getNovaOrdenacao(this.state.ordenacao.data_inicio) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Início {this.getIconeOrdenacao(this.state.ordenacao.data_inicio)}</Th>
									<Th paddingTop={2} paddingBottom={2} width={100}
										onClick={() => this.setState({ ...this.state, ordenacao: { data_termino: this.getNovaOrdenacao(this.state.ordenacao.data_termino) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Término {this.getIconeOrdenacao(this.state.ordenacao.data_termino)}</Th>
									<Th paddingTop={2} paddingBottom={2} width={250}
										onClick={() => this.setState({ ...this.state, ordenacao: { veiculo_local: this.getNovaOrdenacao(this.state.ordenacao.veiculo_local) }})} 
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter>Local {this.getIconeOrdenacao(this.state.ordenacao.veiculo_local)}</Th>
									<Th paddingTop={2} paddingBottom={2} width={80}
										sticky backgroundColor={'#1F3066'} color={'#ffffff'} alignCenter></Th>
								</Tr>
							</THead>
							<TBody>
								{lista.map((item, i) => {

									const trocas = (item.trocas || []).filter(
										troca => !troca.id || troca.ativo
									);

									const trocasAbertas = (
										this.state.linhasTrocasAbertas || []
									).includes(item.id);

									const itemAtrasado = this.estaAtrasado(item);
									const possuiFilhoAtrasado = trocas.some(troca => this.estaAtrasado(troca) );
									const possuiAtraso = itemAtrasado || possuiFilhoAtrasado;

									return (
										<React.Fragment key={item.id}>

											<Tr
												backgroundColor={
													this.state.linhaSelecionada == item.id
														? '#bcc7eb'
														: (i % 2 == 0 ? '#ffffff' : '#f5f5f5')
												}
												onClick={() => this.setState({
													linhaSelecionada: item.id
												})}
											>
												<Td color='#000' alignCenter small>
													{item.nome_motorista}
												</Td>

												<Td color='#000' alignCenter small>
													{item.placa}
												</Td>

												<Td color='#000' alignCenter small title={`${item.nome_motorista_grupo} ${item.nome_grupo_veiculo}`}>
													<p style={{ padding: 0, margin: 0, fontSize: 10 }}>{item.nome_motorista_grupo}</p>
													<p style={{ padding: 0, margin: 0, fontSize: 10 }}>{item.nome_grupo_veiculo}</p>
												</Td>

												<Td color='#000' alignCenter small>
													{item.nome_tipo}
												</Td>

												<Td color='#000' alignCenter small>
													{item.nome_estado}
													{possuiAtraso &&
													<i
														className='fas fa-exclamation-triangle'
														title='Existe item com término em atraso'
														style={{
															color: '#dc3545',
															marginLeft: 6,
															fontSize: 14
														}}
													/>}
												</Td>

												<Td color='#000' alignCenter small>
													{item.nome_motivo}
												</Td>

												<Td color='#000' alignCenter small>
													{DateFormat.formatarDataSqlParaTela(
														item.data_planejamento_inicio
													)}
												</Td>

												<Td color='#000' alignCenter small>
													{DateFormat.formatarDataSqlParaTela(
														item.data_inicio
													)}
												</Td>

												<Td color='#000' alignCenter small>
													{DateFormat.formatarDataSqlParaTela(
														item.data_termino
													)}
												</Td>

												<Td color='#000' alignCenter small>
													{item.veiculo_local}
												</Td>

												<Td minWidth={120} width={120} alignCenter>

													<ButtonTable
														type='primary'
														icon={
															trocasAbertas
																? 'fas fa-minus'
																: 'fas fa-plus'
														}
														visible={true}
														disabled={!trocas.length}
														small
														title={
															trocasAbertas
																? 'Ocultar trocas'
																: 'Visualizar trocas'
														}
														event={() => {
															this.alternarTrocas(item.id);
														}}
													/>

													<ButtonTable
														type='warning'
														icon='fas fa-pencil-alt'
														visible={true}
														small
														event={() => {
															this.props.setModoTela('cadastro', {
																...item
															});

															this.props.initForm({
																...item
															});

															this.props.getListaEmails(item.id);
														}}
													/>

													<ButtonTable
														type='danger'
														icon='fas fa-trash-alt'
														visible={true}
														small
														event={() => {
															this.props.setModoTela('exclusao', {
																...item
															});

															this.props.initForm({
																...item
															});

															this.props.getListaEmails(item.id);
														}}
													/>
												</Td>
											</Tr>

											{trocasAbertas && (
											<Tr>
												<Td colspan={11} color='#01071a' small>

													<div
														style={{
															padding: 8,
															backgroundColor: '#ffffff',
															paddingLeft: 18
														}}
													>
														{trocas.map((troca, indice) => {

															const motorista = this.props.listaMotorista.find(
																itemMotorista =>
																	itemMotorista.id == troca.id_motorista
															);

															const estado = (
																this.props.listaEstadoTrocas || []
															).find(
																itemEstado =>
																	itemEstado.id == troca.id_estado
															);

															return (
																<div
																	key={troca.id || troca.idAux || indice}
																	style={{
																		position: 'relative',
																		borderBottom:
																			indice < trocas.length - 1
																				? '1px solid #d8dee9'
																				: null,
																		paddingTop: indice > 0 ? 12 : 4,
																		paddingBottom:
																			indice < trocas.length - 1
																				? 12
																				: 4,
																		paddingLeft: 18
																	}}
																>
																	{/* Número da troca */}
																	<div
																		style={{
																			position: 'absolute',
																			left: -14,
																			top: indice == 0 ? 24 : 32,
																			width: 26,
																			height: 26,
																			borderRadius: '50%',
																			backgroundColor: troca.id_tipo == 1 ? '#1F3066' : '#28a745',
																			color: '#ffffff',
																			display: 'flex',
																			alignItems: 'center',
																			justifyContent: 'center',
																			fontSize: 12,
																			fontWeight: 700,
																			zIndex: 0,
																			border: '2px solid #ffffff'
																		}}
																	>
																		{troca.ordem || indice + 1}
																	</div>
																	<Row>
																		<Grid cols='12 6 3 3'>
																			<Row>
																				<Grid cols='12 12 12 12'>
																					<div>
																						<strong>Motorista: </strong>
																						{troca.nome_motorista || (motorista ? motorista.valor : '-')}
																					</div>
																				</Grid>

																				<Grid cols='12 12 12 12'>
																					<div>
																						<strong>Leva/Troca: </strong>
																						{troca.leva ? 'Leva' : 'Troca'}
																					</div>
																				</Grid>

																				<Grid cols='12 12 12 12'>
																					<div>
																						
																						{(troca.observacao || '-').split('\n').map((obs, iObs) => (
																							<p style={{ padding: 0, margin: 0 }}>
																								{iObs == 0 &&
																								<strong>Observação: </strong>}
																								{obs}
																							</p>
																						))}
																					</div>
																				</Grid>
																			</Row>
																		</Grid>
																		<Grid cols='12 6 3 3'>
																			<Row>
																				<Grid cols='12 12 12 12'>
																					<div>
																						<strong>Prev. Início: </strong>
																						{DateFormat.formatarDataSqlParaTela(
																							troca.data_previsao_inicio
																						) || '-'}
																					</div>
																				</Grid>

																				<Grid cols='12 12 12 12'>
																					<div>
																						<strong>Início: </strong>
																						{DateFormat.formatarDataSqlParaTela(
																							troca.data_inicio
																						) || '-'}
																					</div>
																				</Grid>

																				<Grid cols='12 12 12 12'>
																					<div>
																						<strong>Término: </strong>
																						{DateFormat.formatarDataSqlParaTela(
																							troca.data_termino
																						) || '-'}
																					</div>
																				</Grid>

																				<Grid cols='12 12 12 12'>
																					<div>
																						<strong>Estado: </strong>
																						{troca.nome_estado || (estado ? estado.valor : '-')}
																					</div>
																				</Grid>
																			</Row>
																		</Grid>
																		<Grid cols='12 12 6 6' style={{ backgroundColor: '#f2f2f2', paddingTop: 8, borderRadius: 4 }}>
																			{troca.id_tipo == 1 &&
																			<Row>
																				<Grid cols='12 12 12 12'>
																					<div
																						style={{
																							display: 'flex',
																							alignItems: 'center',
																							flexWrap: 'wrap',
																							gap: 8
																						}}
																					>
																						<span 
																							style={{
																								display: 'inline-flex',
																								alignItems: 'center',
																								padding: '2px 7px',
																								borderRadius: 10,
																								backgroundColor: '#1f3066',
																								color: '#fff',
																								fontSize: 11,
																								fontWeight: 700,
																								lineHeight: '1.2',
																								whiteSpace: 'nowrap'
																							}}
																						>
																							Viagem
																						</span>

																						<strong>
																							{troca.localizacao || '-'}
																						</strong>

																						<div>
																							{troca.municipio ? ' - ' + troca.municipio || '-' : ''}
																						</div>
																					</div>
																				</Grid>
																			</Row>}


																			{troca.id_tipo == 1 &&
																			<Row>
																				<Grid cols='12 12 12 12'>
																					<div
																						style={{
																							display: 'flex',
																							alignItems: 'center',
																							flexWrap: 'wrap',
																							gap: 16
																						}}
																					>
																						<div>
																							<strong>Placa:</strong>{' '}
																							{troca.placa || '-'}
																						</div>

																						<div>
																							<strong>Shipping:</strong>{' '}
																							{troca.shipping || '-'}
																						</div>

																						<div>
																							<strong>Rumo:</strong>{' '}
																							{troca.rumo || '-'}
																						</div>
																					</div>
																				</Grid>
																			</Row>}


																			{troca.id_tipo == 1 &&
																			<Row>
																				<Grid cols='12 12 12 12'>
																					<div
																						style={{
																							display: 'flex',
																							alignItems: 'center',
																							flexWrap: 'wrap',
																							gap: 16
																						}}
																					>
																						<div>
																							<strong>Prox. Etapa:</strong>{' '}
																							{troca.proxima_etapa || '-'}
																						</div>

																						<div>
																							<strong>Local:</strong>{' '}
																							{troca.nome_etapa || '-'}
																						</div>

																						<div>
																							<strong>Previsão:</strong>{' '}
																							{DateFormat.formatarDataHoraSqlParaTela(
																								troca.data_previsao_etapa
																							) || '-'}
																						</div>
																					</div>
																				</Grid>
																			</Row>}

																		</Grid>
																	</Row>
																</div>
															);
														})}
													</div>
												</Td>
											</Tr>
										)}
										</React.Fragment>
									);
								})}
							</TBody>
						</Table>
					</div>
				</ContentCardBody>
			</ContentCard>
		);
	}

	alternarTrocas = id => {

		const linhasTrocasAbertas = [
			...(this.state.linhasTrocasAbertas || [])
		];

		const aberta = linhasTrocasAbertas.includes(id);

		this.setState({
			linhasTrocasAbertas: aberta
				? linhasTrocasAbertas.filter(item => item !== id)
				: [...linhasTrocasAbertas, id]
		});
	};

	alternarTodasTrocas = () => {

		const lista = this.props.lista || [];

		const linhasAbertas =
			this.state.linhasTrocasAbertas || [];

		const idsComTrocas = lista
			.filter(item =>
				(item.trocas || [])
					.filter(troca => !troca.id || troca.ativo)
					.length > 0
			)
			.map(item => item.id);

		const temAlgumaAberta =
			linhasAbertas.length > 0;

		this.setState({
			linhasTrocasAbertas:
				temAlgumaAberta
					? []
					: idsComTrocas
		});
	}

}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	aguardando: state.motoristaFolga.aguardando,
	modoTela: state.motoristaFolga.modoTela,
	lista: state.motoristaFolga.lista,
	filtro: state.motoristaFolga.filtro,
	listaMotorista: state.motoristaFolga.listaMotorista,
	listaPlaca: state.motoristaFolga.listaPlaca,
	listaTipo: state.motoristaFolga.listaTipo,
	listaEstado: state.motoristaFolga.listaEstado,
	listaMotivo: state.motoristaFolgaMotivo.listaSelect,
	listaGrupo: state.gestaoVMGrupo.listaSelect,
	listaEstadoTrocas: state.motoristaFolga.listaEstadoTrocas,
	listaMotoristaGrupo: state.motoristaGrupo.listaSelect
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, setFiltro, initForm, salvar, excluir, getLista, getListaMotorista, getListaPlaca, getListaTipo, getListaEstado,
	getListaMotivo, getListaGrupo, getListaEstadoTroca, getListaGrupoEmail, getListaMotoristaGrupo, getListaCidadeSelect,
	getListaEmails
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(MotoristaFolga);
